import { RaidStageKind } from './stage'
import type { RaidStageKind as RaidStageKindType } from './stage'

export const BuildPresetSource = {
  Personal: 'personal',
  Guild: 'guild',
} as const

export type BuildPresetSource = (typeof BuildPresetSource)[keyof typeof BuildPresetSource]

export const MAX_BUILD_PRESETS = 12

/** Planned stage pairs. Opening inherits Towers, which is the canonical ALL build. */
export const BUILD_PRESET_STAGE_KINDS: ReadonlyArray<RaidStageKindType> = [
  RaidStageKind.MidPush,
  RaidStageKind.LateDefense,
  RaidStageKind.Forest,
  RaidStageKind.Endgame,
  RaidStageKind.Custom,
]

export interface BuildPresetStage {
  readonly stageKind: RaidStageKindType
  readonly weaponSlugs: ReadonlyArray<string>
}

export interface BuildPreset {
  readonly id: string
  readonly name: string
  readonly orderIndex: number
  readonly stages: ReadonlyArray<BuildPresetStage>
}

export interface PlayerBuildPresetOwner {
  readonly discordUserId: string
  readonly presets: ReadonlyArray<BuildPreset>
}

export interface BuildPresetLibrary {
  readonly playerPresets: ReadonlyArray<PlayerBuildPresetOwner>
  readonly guildPresets: ReadonlyArray<BuildPreset>
}
